import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const taStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'WhatsApp இல் அழைக்கவும்',
  NLSWhatsappInviteDialogTitle: 'WhatsApp இல் அழைக்கவும்',
  NLSWhatsappInviteDialogCopy: 'இணைப்பை நகலெடு',
  NLSWhatsappInviteDialogShare: 'பகிர்',
  NLSWhatsappSendFromMineAction: 'எனது WhatsApp இலிருந்து அனுப்பு',
  NLSWhatsappSendFromMineText: 'வணக்கம் {name}, நான் {workspace} இலிருந்து {sender}.',
  NLSWhatsappSlipQrCaption: 'WhatsApp இல் எங்களுடன் அரட்டையடிக்கவும்',
  NLSWhatsappChipLinked: 'வாட்ஸ்அப் இணைக்கப்பட்டது',
  NLSWhatsappChipNotYet: 'வாட்ஸ்அப்: இன்னும் இல்லை',
  NLSWhatsappChipStopped: 'வாட்ஸ்அப்: நிறுத்தப்பட்டது',
  NLSEduAnnouncementSendWhatsappAction: 'வாட்ஸ்அப்பில் அனுப்பு',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'வாட்ஸ்அப்பில் அனுப்பு',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'அனுப்பு',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: '{n} பாதுகாவலர்களுக்கு அனுப்பப்படும்',
  NLSEduAnnouncementSendWhatsappSummaryCredits: '{n} பாதுகாவலர்களுக்கு அனுப்பப்படும் · சுமார் {credits} கிரெடிட்கள்',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'உங்கள் திட்ட வரம்பிற்குள் இலவசம்',
  NLSEduAnnouncementSendWhatsappReasonOff: 'இந்த பணியிடத்திற்கு வாட்ஸ்அப் முடக்கப்பட்டுள்ளது.',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'அமைப்புகளில் நிர்வாகி அறிவிப்புகள் அனுப்புதல் முடக்கப்பட்டுள்ளது.',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'சரிபார்க்கப்பட்ட தொலைபேசி ஒப்புதல் கொண்ட பாதுகாவலர்கள் எவரும் காணப்படவில்லை.',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'போதுமான கிரெடிட்கள் இல்லாததால் வாட்ஸ்அப் அனுப்புதல் இடைநிறுத்தப்பட்டுள்ளது.',
  NLSEduAnnouncementSentWhatsappCount: 'வாட்ஸ்அப்பில் {count} நபருக்கு அனுப்பப்பட்டது',
  NLSCommonRailPageShellSidecarSheet: "விவரங்கள் குழு",
  NLSCommonActionSignOut: 'வெளியேறு',
  NLSCommonLanguageLabel: 'மொழி',
  NLSCommonLanguageAriaLabel: 'ஆப் மொழி',
  NLSInvitesHelperAppLanguageTitle: 'Helper ஆப் மொழி',
  NLSInvitesHelperAppLanguageBody: 'இந்த workspace-இல் இந்த helper-க்கு Helper ஆப் UI இந்த மொழியில் தெரியும்.',
  NLSInvitesHelperAppLanguageAria: 'Helper ஆப் மொழி',
  NLSMobileSettingsHelperAppLanguageTitle: 'Helper ஆப் மொழி',
  NLSMobileSettingsHelperAppLanguageBody: 'Helper ஆப்பின் பட்டன்கள், settings, UI மட்டும் மாறும். Chat translation மாறாது.',
  NLSMobileSettingsHelperAppLanguageSaved: 'Helper ஆப் மொழி சேமிக்கப்பட்டது.',
  NLSHelperTabTodos: 'பணிகள்',
  NLSHelperTabCalendar: 'காலண்டர்',
  NLSHelperTabMeetings: 'கூட்டங்கள்',
  NLSHelperTabChat: 'அரட்டை',
  NLSHelperTabControls: 'கட்டுப்பாடுகள்',
  NLSHelperSubtabScan: 'ஸ்கேன்',
  NLSHelperSubtabMe: 'நான்',
  NLSHelperSubtabForms: 'படிவங்கள்',
  NLSHelperSubtabSync: 'ஒத்திசைவு',
  NLSHelperPanelSettings: 'Helper settings',
  NLSHelperPanelCommandPreferences: 'Command விருப்பங்கள்',
  NLSHelperSettingsTitle: 'Settings',
  NLSHelperSettingsLanguage: 'மொழி',
  NLSHelperSettingsLanguageAria: 'Helper மொழி',
  NLSOpsRequestKindReliefNeeded: 'மாற்றுப் பணியாளர் தேவை',
  NLSOpsRequestKindIncident: 'சம்பவம்',
  NLSOpsRequestKindClientComplaint: 'வாடிக்கையாளர் புகார்',
  NLSOpsRequestKindSupplyRequest: 'வழங்கல் கோரிக்கை',
  NLSOpsRequestKindPm: 'தடுப்பு பராமரிப்பு',
  NLSOpsRequestKindCalibration: 'அளவுத்திருத்தம்',
  NLSOpsReliefNeededTitle: 'மாற்று தேவை: {placeName} இல் {roleLabel} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'தளம் மற்றும் பணிமுறைக்கான பணி இடுகைகள் · ஒரு வருகையின்மை மாற்று கோரிக்கையை எழுப்புகிறது',
  NLSOpsSitesSelectSite: 'தளத்தைத் தேர்ந்தெடுக்கவும்',
  NLSOpsSitesDay: 'நாள்',
  NLSOpsSitesSelectShift: 'பணிமுறையைத் தேர்ந்தெடுக்கவும்',
  NLSOpsSitesPostsBoardTitle: 'இடுகைகள் மற்றும் மாற்று',
  NLSOpsSitesColPost: 'இடுகை',
  NLSOpsSitesColNeeds: 'தேவைகள்',
  NLSOpsSitesColOnDuty: 'பணியில்',
  NLSOpsSitesColState: 'நிலை',
  NLSOpsSitesStateCovered: 'நிரப்பப்பட்டது',
  NLSOpsSitesStateShort: 'குறைவு',
  NLSOpsSitesStateReliefNeeded: 'மாற்று தேவை',
  NLSOpsSitesStateReliefAssigned: 'மாற்று ஒதுக்கப்பட்டது',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'வரவில்லை',
  NLSOpsSitesReliefInbox: 'மாற்று இன்பாக்ஸ்',
  NLSOpsSitesReliefFootnote: 'வருகை பட்டியலில் இல்லாமை தானாகவே RELIEF_NEEDED கோரிக்கையை எழுப்பி கவரேஜ் எச்சரிக்கிறது (A6).',
  NLSOpsSitesFreeCandidates: 'கிடைக்கும் வேட்பாளர்கள்:',
  NLSOpsSitesOffToday: 'இன்று விடுமுறை',
  NLSOpsSitesAssignBtn: 'ஒதுக்கு',
  NLSOpsSitesAssignCandidateBtn: '{name} ஒதுக்கு',
  NLSOpsSitesAssignDialogTitle: 'மாற்று நபரை ஒதுக்கு',
  NLSOpsSitesPrintPostSheet: 'இடுகை தாளை அச்சிடுக',
  NLSOpsSitesNoPosts: 'இந்த தளத்திற்கு பணி இடுகைகள் எதுவும் கட்டமைக்கப்படவில்லை.',
  NLSOpsSitesNoReliefNeeded: 'மாற்று எதுவும் தேவையில்லை.',
  NLSOpsSitesNoSites: 'வாடிக்கையாளர் தளங்கள் எதுவும் கிடைக்கவில்லை.',
  NLSOpsSitesNoShifts: 'பணிமுறைகள் எதுவும் இல்லை.',
  NLSOpsSitesPostSheetTitle: 'இடுகை தாள் · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'மாற்றை ஒதுக்க முடியாது: கோரிக்கை இப்போது திறக்கப்படவில்லை.',
  NLSOpsSitesErrorOnLeave: 'மாற்றை ஒதுக்க முடியாது: நபர் அனுமதிக்கப்பட்ட விடுப்பில் உள்ளார்.',
  NLSOpsSitesErrorDoubleBooked: 'மாற்றை ஒதுக்க முடியாது: நபர் ஏற்கனவே இந்த பணிமுறைக்கு ஒதுக்கப்பட்டுள்ளார்.',
  NLSOpsSitesErrorRoleCeiling: 'மாற்றை ஒதுக்க முடியாது: உறுப்பினர் பங்கு வரம்பு பணி ஒதுக்கீட்டைத் தடுக்கிறது.',
  NLSOpsSitesErrorGeneric: 'மாற்றை ஒதுக்க முடியவில்லை.',
  NLSOpsSitesErrorNotFound: 'பதிவு அல்லது கோரிக்கை காணப்படவில்லை.',
  NLSOpsSitesErrorMissingAttributes: 'கோரிக்கையில் தேவையான மாற்றுப் பண்புக்கூறுகள் இல்லை.',
  NLSOpsSitesErrorInactivePerson: 'மாற்றை ஒதுக்க முடியாது: நபர் பணியிடத்தில் செயலற்றவராக உள்ளார்.',
  NLSOpsRequestsUnassigned: 'ஒதுக்கப்படவில்லை',
  NLSOpsRequestsDetailUnassigned: 'ஒதுக்கப்படவில்லை',
  NLSOpsSitesIncidentsSubtitle: 'சம்பவங்கள் (கட்டுப்படுத்தப்பட்டது) · வாடிக்கையாளர் புகார்கள் · விநியோக கோரிக்கைகள் · மேற்பார்வையாளர் தணிக்கை',
  NLSOpsSitesIncidentsTitle: 'சம்பவங்கள்',
  NLSOpsSitesRestrictedTag: 'கட்டுப்படுத்தப்பட்டது',
  NLSOpsSitesAuditScoresTitle: 'தள தணிக்கை மதிப்பெண்கள்',
  NLSOpsSitesSupervisorRegisterTag: 'மேற்பார்வையாளர் பதிவேடு',
  NLSOpsSitesColSite: 'தளம்',
  NLSOpsSitesColLastAudit: 'கடைசி தணிக்கை',
  NLSOpsSitesColScore: 'மதிப்பெண்',
  NLSOpsSitesRecordAuditBtn: 'தணிக்கையைப் பதிவு செய்',
  NLSOpsSitesComplaintsSupplyTitle: 'புகார்கள் மற்றும் விநியோக கோரிக்கைகள்',
  NLSOpsSitesNoIncidents: 'சம்பவங்கள் எதுவும் பதிவு செய்யப்படவில்லை.',
  NLSOpsSitesNoComplaintsSupply: 'புகார்கள் அல்லது விநியோக கோரிக்கைகள் எதுவும் இல்லை.',
  NLSOpsSitesNoAudits: 'தள தணிக்கைகள் எதுவும் பதிவு செய்யப்படவில்லை.',
  NLSOpsSitesNoAuditTemplate: 'மேற்பார்வையாளர் தள தணிக்கை டெம்ப்ளேட் எதுவும் கட்டமைக்கப்படவில்லை.',
  NLSOpsSitesOpenTemplatesBtn: 'டெம்ப்ளேட்டுகளைத் திறக்கவும்',
} satisfies Partial<NlsStringMap>

export default taStringsNls
